import { render, staticRenderFns } from "./CompareRestaurantPrimaryCell.vue?vue&type=template&id=51d94ba6&"
import script from "./CompareRestaurantPrimaryCell.vue?vue&type=script&lang=js&"
export * from "./CompareRestaurantPrimaryCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports